"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));
var _queryString = _interopRequireDefault(require("query-string"));
var _mobx = require("mobx");
var _priceFilter = _interopRequireDefault(require("./price-filter.store"));
var _stopFilter = _interopRequireDefault(require("./stop-filter.store"));
var _airlineFilter = _interopRequireDefault(require("./airline-filter.store"));
var _airportFilter = _interopRequireDefault(require("./airport-filter.store"));
var _baggageFilter = _interopRequireDefault(require("./baggage-filter.store"));
var _timeFilter = _interopRequireDefault(require("./time-filter.store"));
var _each2 = _interopRequireDefault(require("lodash/each"));
var _every2 = _interopRequireDefault(require("lodash/every"));
var _mapKeys2 = _interopRequireDefault(require("lodash/mapKeys"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _some2 = _interopRequireDefault(require("lodash/some"));
var _values2 = _interopRequireDefault(require("lodash/values"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _isArray2 = _interopRequireDefault(require("lodash/isArray"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));
var _helpers = require("../../utils/helpers.utils");
var _flatMap2 = _interopRequireDefault(require("lodash/flatMap"));
var _common = require("../../utils/filters/common.utils");
var _search = require("../../utils/search.utils");
var _filters = require("../../constants/filters.constants");
var _FILTER_MAP$PRICE, _FILTER_MAP$STOP, _FILTER_MAP$AIRLINE, _FILTER_MAP$AIRPORT, _FILTER_MAP$BAGGAGE, _FILTER_MAP$TIME;
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var FiltersStore = exports.default = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, _dec4 = _mobx.action.bound, _dec5 = _mobx.action.bound, _dec6 = _mobx.action.bound, _dec7 = _mobx.action.bound, _dec8 = _mobx.action.bound, _dec9 = _mobx.action.bound, _dec10 = _mobx.action.bound, _dec11 = _mobx.action.bound, (_class = (_FILTER_MAP$PRICE = _filters.FILTER_MAP.PRICE, _FILTER_MAP$STOP = _filters.FILTER_MAP.STOP, _FILTER_MAP$AIRLINE = _filters.FILTER_MAP.AIRLINE, _FILTER_MAP$AIRPORT = _filters.FILTER_MAP.AIRPORT, _FILTER_MAP$BAGGAGE = _filters.FILTER_MAP.BAGGAGE, _FILTER_MAP$TIME = _filters.FILTER_MAP.TIME, function () {
  function FiltersStore(filterData, $env, flightInfo) {
    if (filterData === void 0) {
      filterData = {
        price: {
          min: 0,
          max: 100
        }
      };
    }
    (0, _classCallCheck2.default)(this, FiltersStore);
    this.$env = void 0;
    this[_FILTER_MAP$PRICE] = void 0;
    this[_FILTER_MAP$STOP] = void 0;
    this[_FILTER_MAP$AIRLINE] = void 0;
    this[_FILTER_MAP$AIRPORT] = void 0;
    this[_FILTER_MAP$BAGGAGE] = void 0;
    this[_FILTER_MAP$TIME] = void 0;
    this.flightInfo = void 0;
    (0, _initializerDefineProperty2.default)(this, "data", _descriptor, this);
    (0, _initializerDefineProperty2.default)(this, "filterKeys", _descriptor2, this);
    (0, _initializerDefineProperty2.default)(this, "searchQuery", _descriptor3, this);
    (0, _initializerDefineProperty2.default)(this, "isAMFormat", _descriptor4, this);
    (0, _initializerDefineProperty2.default)(this, "isRestoringPreservedFilters", _descriptor5, this);
    this.$env = $env;
    this.flightInfo = flightInfo;
    this.setData(filterData);
    this[_filters.FILTER_MAP.PRICE] = new _priceFilter.default(filterData[_filters.FILTER_MAP.PRICE], $env);
    this[_filters.FILTER_MAP.STOP] = new _stopFilter.default(filterData[_filters.FILTER_MAP.STOP], $env);
    this[_filters.FILTER_MAP.AIRLINE] = new _airlineFilter.default(filterData[_filters.FILTER_MAP.AIRLINE], $env, flightInfo);
    this[_filters.FILTER_MAP.AIRPORT] = new _airportFilter.default(filterData[_filters.FILTER_MAP.AIRPORT], $env, flightInfo);
    this[_filters.FILTER_MAP.BAGGAGE] = new _baggageFilter.default(filterData[_filters.FILTER_MAP.BAGGAGE], $env);
    this[_filters.FILTER_MAP.TIME] = new _timeFilter.default(filterData[_filters.FILTER_MAP.TIME], $env);
  }
  (0, _createClass2.default)(FiltersStore, [{
    key: "filterList",
    get: function get() {
      var _ref;
      return _ref = {}, _ref[_filters.FILTER_MAP.PRICE] = this[_filters.FILTER_MAP.PRICE], _ref[_filters.FILTER_MAP.STOP] = this[_filters.FILTER_MAP.STOP], _ref[_filters.FILTER_MAP.AIRLINE] = this[_filters.FILTER_MAP.AIRLINE], _ref[_filters.FILTER_MAP.AIRPORT] = this[_filters.FILTER_MAP.AIRPORT], _ref[_filters.FILTER_MAP.BAGGAGE] = this[_filters.FILTER_MAP.BAGGAGE], _ref[_filters.FILTER_MAP.TIME] = this[_filters.FILTER_MAP.TIME], _ref;
    }
  }, {
    key: "topAirlines",
    get: function get() {
      return this.flightInfo.topAirlines.getValidTopAirlines({
        route: (0, _search.getRouteFromQuery)(this.searchQuery),
        airlines: (0, _map2.default)(this.airline.state, "code")
      });
    }
  }, {
    key: "state",
    get: function get() {
      return (0, _mapValues2.default)(this.filterList, function (filter) {
        return filter.state;
      });
    }
  }, {
    key: "isDirty",
    get: function get() {
      return (0, _some2.default)(this.filterList, function (filter) {
        return filter.isDirty;
      });
    }
  }, {
    key: "isTouched",
    get: function get() {
      return (0, _some2.default)(this.filterList, function (filter) {
        return filter.isTouched;
      });
    }
  }, {
    key: "isPristine",
    get: function get() {
      return (0, _every2.default)(this.filterList, function (filter) {
        return filter.isPristine;
      });
    }
  }, {
    key: "isUncommitted",
    get: function get() {
      return (0, _some2.default)(this.filterList, function (filter) {
        return filter.isUncommitted;
      });
    }
  }, {
    key: "query",
    get: function get() {
      var queryMap = (0, _mapValues2.default)(this.filterList, function (filter) {
        return filter.query;
      });
      return (0, _mapKeys2.default)(queryMap, function (value, key) {
        return _filters.FILTER_PARAM_MAP[key];
      });
    }
  }, {
    key: "queryStr",
    get: function get() {
      return decodeURIComponent(_queryString.default.stringify(this.query));
    }
  }, {
    key: "appliedCount",
    get: function get() {
      return (0, _filter2.default)(this.filterList, function (filter) {
        return filter.isDirty;
      }).length;
    }
  }, {
    key: "isReady",
    get: function get() {
      return (0, _some2.default)(this.filterList, function (filter) {
        return filter.isReady;
      });
    }
  }, {
    key: "defaultQuickFilters",
    get: function get() {
      var _this = this;
      return (0, _map2.default)(_filters.QUICK_FILTERS, function (quickFilter) {
        var id = quickFilter.id,
          filter = quickFilter.filter;
        return _objectSpread(_objectSpread({}, quickFilter), {}, {
          isActive: _this[filter][id],
          isAvailable: (0, _common.checkQuickFilterAvailability)(_this[filter])
        });
      });
    }
  }, {
    key: "topAirlinesQuickFilters",
    get: function get() {
      var _this2 = this;
      return (0, _map2.default)(this.topAirlines, function (airlineCode) {
        return {
          id: airlineCode,
          filter: _filters.FILTER_MAP.AIRLINE,
          toggleMethod: "toggle",
          payload: [airlineCode],
          isActive: _this2.airline.isSelected(airlineCode),
          label: _this2.flightInfo.$resources.getAirlineLabel(airlineCode),
          isAvailable: true
        };
      });
    }
  }, {
    key: "quickAppliedFilters",
    get: function get() {
      return (0, _common.getQuickAppliedFilters)((0, _flatMap2.default)(this.filterList, function (filter) {
        return (0, _common.getQuickAppliedFilter)(filter);
      }), this.topAirlinesQuickFilters);
    }
  }, {
    key: "quickFilters",
    get: function get() {
      var filters = [].concat(this.defaultQuickFilters, this.topAirlinesQuickFilters, this.quickAppliedFilters);
      return (0, _filter2.default)(filters, function (filter) {
        return filter.isAvailable;
      });
    }
  }, {
    key: "quickFilterMap",
    get: function get() {
      return (0, _keyBy2.default)(this.quickFilters, "id");
    }
  }, {
    key: "filter",
    value: function filter(itineraries) {
      var _this3 = this;
      return (0, _filter2.default)(itineraries, function (_ref2) {
        var filtersData = _ref2.filtersData;
        return (0, _every2.default)(_this3.filterList, function (_ref3) {
          var filter = _ref3.filter,
            id = _ref3.id;
          return filter(filtersData === null || filtersData === void 0 ? void 0 : filtersData[id]);
        });
      });
    }
  }, {
    key: "initialize",
    value: function initialize(data, searchQuery, urlParams) {
      this.searchQuery = searchQuery;
      if ((0, _isEqual2.default)(this.data, data)) {
        return;
      }
      this.setData(data);
      (0, _each2.default)(this.filterList, function (_ref4) {
        var initialize = _ref4.initialize,
          id = _ref4.id;
        var urlParam = _filters.FILTER_PARAM_MAP[id];
        initialize(data === null || data === void 0 ? void 0 : data[id], urlParams === null || urlParams === void 0 ? void 0 : urlParams[urlParam], true);
      });
    }
  }, {
    key: "update",
    value: function update(query, withCommit) {
      var _this4 = this;
      if (withCommit === void 0) {
        withCommit = false;
      }
      var queryObject = (0, _pick2.default)(query, (0, _values2.default)(_filters.FILTER_PARAM_MAP));
      (0, _each2.default)(queryObject, function (filterQuery, filterId) {
        var filterKey = (0, _helpers.getObjectValueByKey)(_filters.FILTER_PARAM_MAP, filterId);
        _this4.filterList[filterKey].update(filterQuery, withCommit);
      });
    }
  }, {
    key: "commit",
    value: function commit() {
      this.isDirty && (0, _each2.default)(this.filterList, function (_ref5) {
        var commit = _ref5.commit;
        return commit();
      });
    }
  }, {
    key: "revert",
    value: function revert() {
      (0, _each2.default)(this.filterList, function (_ref6) {
        var revert = _ref6.revert;
        return revert();
      });
    }
  }, {
    key: "reset",
    value: function reset(withCommit) {
      if (withCommit === void 0) {
        withCommit = false;
      }
      (0, _each2.default)(this.filterList, function (_ref7) {
        var reset = _ref7.reset;
        return reset(withCommit);
      });
    }
  }, {
    key: "setFilterKeys",
    value: function setFilterKeys(filterKeys) {
      if ((0, _isArray2.default)(filterKeys)) {
        this.filterKeys = filterKeys;
      }
    }
  }, {
    key: "setData",
    value: function setData(data) {
      this.data = data;
    }
  }, {
    key: "toggleQuickFilter",
    value: function toggleQuickFilter(quickFilterId) {
      var quickFilter = this.quickFilterMap[quickFilterId];
      if (!(0, _isEmpty2.default)(quickFilter)) {
        var filter = quickFilter.filter,
          toggleMethod = quickFilter.toggleMethod,
          payload = quickFilter.payload;
        try {
          this[filter][toggleMethod](payload, true);
          this.setRestoringPreservedFilters(false);
        } catch (e) {
          console.debug("Please make sure that filter type is exist or the toggleMethod is implemented inside the filter");
        }
      }
    }
  }, {
    key: "setRestoringPreservedFilters",
    value: function setRestoringPreservedFilters(isRestoring) {
      this.isRestoringPreservedFilters = isRestoring;
    }
  }, {
    key: "clone",
    value: function clone(filterStore) {
      this[_filters.FILTER_MAP.BAGGAGE].clone(filterStore[_filters.FILTER_MAP.BAGGAGE].state);
      this[_filters.FILTER_MAP.STOP].clone(filterStore[_filters.FILTER_MAP.STOP].state);
      this[_filters.FILTER_MAP.AIRLINE].clone(filterStore[_filters.FILTER_MAP.AIRLINE].state);
    }
  }, {
    key: "toggleAMFormat",
    value: function toggleAMFormat() {
      this.isAMFormat = !this.isAMFormat;
    }
  }]);
  return FiltersStore;
}()), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "data", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filterKeys", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return (0, _values2.default)(_filters.FILTER_MAP);
  }
}), _descriptor3 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "searchQuery", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isAMFormat", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor5 = (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isRestoringPreservedFilters", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filterList", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "filterList"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topAirlines", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topAirlines"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "state", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "state"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isDirty", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isDirty"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isTouched", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isTouched"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isPristine", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isPristine"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isUncommitted", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isUncommitted"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "query", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "query"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "queryStr", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "queryStr"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "appliedCount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "appliedCount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isReady", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isReady"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "defaultQuickFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "defaultQuickFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "topAirlinesQuickFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "topAirlinesQuickFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "quickAppliedFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "quickAppliedFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "quickFilters", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "quickFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "quickFilterMap", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "quickFilterMap"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "filter", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "filter"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "initialize", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "update", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "update"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "commit", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "commit"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "revert", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "revert"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "reset", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "reset"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setFilterKeys", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "setFilterKeys"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setData", [_dec7], Object.getOwnPropertyDescriptor(_class.prototype, "setData"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "toggleQuickFilter", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "toggleQuickFilter"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "setRestoringPreservedFilters", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "setRestoringPreservedFilters"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "clone", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "clone"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "toggleAMFormat", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAMFormat"), _class.prototype)), _class));